import { Component, inject } from '@angular/core';
import { MatCardModule } from '@angular/material/card';

import { AppGeneralStateService } from 'src/app/app-general-state.service';
import { HeaderTitleLotDataComponent } from 'src/app/shared/ui/header-title-lot-data/header-title-lot-data.component';

@Component({
  selector: 'app-tasks-jobs-settings',
  standalone: true,
  imports: [MatCardModule, HeaderTitleLotDataComponent],
  templateUrl: './tasks-jobs-settings.component.html',
  styleUrl: './tasks-jobs-settings.component.scss'
})
export class TasksJobsSettingsComponent {
  _appGeneralState = inject(AppGeneralStateService);
}
